var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 10.5832C15.2501 10.5832 10.5834 15.2498 10.5834 20.9998C10.5834 26.7498 15.2501 31.4165 21.0001 31.4165C26.7501 31.4165 31.4167 26.7498 31.4167 20.9998C31.4167 15.2498 26.7501 10.5832 21.0001 10.5832ZM21.0001 0.166504C9.50008 0.166504 0.166748 9.49984 0.166748 20.9998C0.166748 32.4998 9.50008 41.8332 21.0001 41.8332C32.5001 41.8332 41.8334 32.4998 41.8334 20.9998C41.8334 9.49984 32.5001 0.166504 21.0001 0.166504ZM21.0001 37.6665C11.7917 37.6665 4.33342 30.2082 4.33342 20.9998C4.33342 11.7915 11.7917 4.33317 21.0001 4.33317C30.2084 4.33317 37.6668 11.7915 37.6668 20.9998C37.6668 30.2082 30.2084 37.6665 21.0001 37.6665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.4d653343c783343dbdba165677cc99a2.svg";
export { ForwardRef as ReactComponent };